import {Portal, Snackbar, Typography} from '@mui/material'
import {BoldCheckIcon, SuccessAlert} from '../FilterPanelStyle'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import PropTypes from 'prop-types'

const SaveFilterSnackBar = ({isSnackBarOpen, handleSnackbarClose, data, action}) => {
  const getIcon = () => {
    if (action === 'add') {
      return <BoldCheckIcon fontSize='inherit' />
    } else if (action === 'delete') {
      return <DeleteOutlineIcon fontSize='inherit' color='error' />
    }
  }

  return (
    <>
      {/* Snackbar rendered here */}
      <Portal>
        <Snackbar
          anchorOrigin={{vertical: 'top', horizontal: 'center'}}
          open={isSnackBarOpen}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
        >
          <SuccessAlert icon={getIcon()} severity='success' onClose={handleSnackbarClose}>
            <Typography>{data}</Typography>
          </SuccessAlert>
        </Snackbar>
      </Portal>
    </>
  )
}

SaveFilterSnackBar.propTypes = {
  isSnackBarOpen: PropTypes.bool.isRequired,
  handleSnackbarClose: PropTypes.func.isRequired,
  data: PropTypes.node.isRequired,
  action: PropTypes.string.isRequired
}

export default SaveFilterSnackBar
